import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, l = /* @__PURE__ */ e("path", { d: "M12 2.75a6.242 6.242 0 0 1 3.32.988l1.079-1.08A7.736 7.736 0 0 0 12.09 1.25h-.18c-4.18.08-7.58 3.49-7.61 7.67v5.837l1.5-1.5V8.92c.02-3.39 2.8-6.14 6.2-6.17Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M5.596 16.29 16.814 5.072l1.063-1.063 1.716-1.716a.75.75 0 0 1 1.06 1.06l-1.91 1.911a7.616 7.616 0 0 1 .958 3.646v6.17c0 1.23 1.01 2.23 2.25 2.23H22c.41 0 .75.34.75.75s-.34.75-.75.75h-6.25v.18A3.76 3.76 0 0 1 12 22.75a3.76 3.76 0 0 1-3.75-3.76v-.18H5.198l-2.053 2.053a.75.75 0 1 1-1.061-1.06l3.512-3.513Zm1.102 1.02H18.95c-.47-.62-.75-1.39-.75-2.23V8.92a6.105 6.105 0 0 0-.57-2.543L6.698 17.31Zm7.553 1.68c0 1.25-1.01 2.26-2.25 2.26s-2.25-1.01-2.25-2.26v-.18h4.5v.18Z",
  "clip-rule": "evenodd"
}, null, -1), s = [
  l,
  n
];
function a(d, r) {
  return t(), o("svg", c, [...s]);
}
const h = { render: a };
export {
  h as default,
  a as render
};
